<div [height]="20"></div>
<div align="center" class="h3Font b1Color">{{ 'BRIXX_SUBSCRIPTION_ID' | translate }}:</div>
<div align="center" class="p2Font g4Color">{{UserSubscription.SubscriptionReference}}</div>

<!--<div *ngIf="UserSubscription.AutoRenew" [height]="50" class="subscription-switch h3Font" i18n>Switching to {{subcriptionType}} {{price}} GBP {{billingFrequency}} + tax - <u style="cursor: pointer" (click)="Cancel()">Cancel switch</u></div>
<div *ngIf="!UserSubscription.AutoRenew"
     class="green-banner cnt-row-centered"
     [height]="50">
    <div class="h4Font i2Color" i18n>Switch to annual for 20% off - <span class="buyCls" data-testid="buyNowLink" (click)="BuyNow()">Buy now</span></div>
</div>

<div *ngIf="!UserSubscription.AutoRenew"
     class="red-banner cnt-row-centered"
     [height]="50">
    <div class="h4Font c2Color" i18n>Subscription is ending - <span class="buyCls" data-testid="stopCancellationLink" (click)="onSubscriptionCancelClick()">Stop cancellation</span></div>
</div>-->

<div [height]="10" *ngIf="!UserSubscription.AutoRenew && UserSubscription.IsSubscriptionDowngradeActive"></div>

<div *ngIf="UserSubscription.IsSubscriptionDowngradeActive"
     class="downgrade-banner cnt-column-centered">
    <span class="downgrade-banner-text">You’ve recently downgraded your plan to <b>{{downgradePlansCount}}</b> plan</span>
    <span class="downgrade-banner-text">Starting {{downgradeDate}}</span>
    <div class="cancel-downgrading" data-testid="stopDowngradeLink" (click)="onSubscriptionDowngradeCancelClick()">CANCEL DOWNGRADING</div>

</div>

<div [height]="15"></div>
<div [width]="400" class="line" style="margin: auto"></div>
<div [height]="5"></div>

<table cols="2" cellspacing="0" cellpadding="0">
    <tr class="rw" *ngIf="UserSubscription.LicenseType != ''">
        <td class="left-text">
            <div data-testid="SubcriptionType" [hidden]="licenseExpired || !UserSubscription.SubscriptionEnabled" i18n>
                {{getPackageType()}} <br /> {{fee}}
            </div>
        </td>
        <td class="right-ref">
            <div data-testid="ChangeSubscriptionPlan" (click)="toChangeSubscriptionPlan()" class="h5Font subscription-link">
                <span data-testid="ChangeSubscriptionPlan" i18n>{{ 'CHANGE_SUBSCRIPTION_PLAN' | translate }}</span>
            </div>
        </td>
    </tr>
    <tr class="line"><td colspan="2"></td><td></td></tr>
    <tr class="rw">
        <td [ngClass]="{'left-text': !useRedText, 'left-text-red': useRedText || UserSubscription.IsSubscriptionDowngradeActive}">
            <div data-testid="BillingExpirationDate">{{expirationDate}}</div>
            <!--<div *ngIf="UserSubscription.IsSubscriptionDowngradeActive" i18n>Downgrading on {{UserSubscription.DowngradeDate}}</div>-->
        </td>
        <td class="right-ref">
            <div [hidden]="licenseExpired || !UserSubscription.SubscriptionEnabled" (click)="onSubscriptionCancelClick()" data-testid="SubscriptionRenew" class="h5Font subscription-link">
                <span data-testid="CancellationStop" [hidden]="UserSubscription.AutoRenew" i18n>{{ 'STOP_CANCELLATION' | translate }}</span>
                <span data-testid="CancelSubscription" [hidden]="!UserSubscription.AutoRenew" i18n>{{ 'CANCEL' | translate }}</span>
                <!--            <span [hidden]="!UserSubscription.AutoRenew">CANCEL SUBSCRIPTION</span>-->
            </div>
            <div [hidden]="!licenseExpired" (click)="onSubscriptionSubscribeAgainClick()" data-testid="SubscribeAgain" class="h5Font subscription-link" i18n>{{ 'SUBSCRIBE_AGAIN' | translate }}</div>
        </td>
    </tr>
    <tr class="line"><td colspan="2"></td><td></td></tr>
    <tr class="rw">
        <td class="left-text g5Color" data-testid="PaymentMethodText">{{ paymentMethod | translate }}</td>
        <td class="right-ref">
            <div [hidden]="licenseExpired" (click)="onUpdateCreditCardClick()" data-testid="UpdateCreditCard" class="h5Font subscription-link" i18n>{{ 'UPDATE' | translate }}</div>
        </td>
    </tr>
    <tr class="line"><td colspan="2"></td><td></td></tr>
    <!--tr class="rw" *ngIf="UserSubscription.LicenseType != ''">
        <td class="left-text g5Color" data-testid="LicensesAssignedText" i18n>Organisations assigned</td>
        <td class="right-ref">
            <div [hidden]="licenseExpired" class="p1Font b1Color">{{UserSubscription.LicensesAssigned}}</div>
        </td>
    </tr>
    <tr class="line"><td colspan="2"></td><td></td></tr-->
</table>
<div style="height:25px"></div>
